import type { ColumnDef } from '@tanstack/react-table'

import { BankAccountInterface } from '@/types'

export const BANK_ACCOUNTS_COLUMN_WIDTHS: Partial<Record<string, string>> = {
  iban: 'minmax(280px, 2fr)',
  currency: 'minmax(120px, 1fr)',
  bank: 'minmax(200px, 1.5fr)',
  status: 'minmax(140px, 1fr)',
}

export const COLUMNS: ColumnDef<BankAccountInterface, unknown>[] = [
  {
    id: 'iban',
    header: 'IBAN',
    cell: ({ row }) => row.original.iban,
  },
  {
    id: 'currency',
    header: 'Валюта',
    cell: ({ row }) => row.original.currencyModel?.description,
  },
  {
    id: 'bank',
    header: 'Банк',
    cell: ({ row }) => row.original.bankDto?.description,
  },
  {
    id: 'status',
    header: 'Статус',
    cell: ({ row }) => (row.original.isMain ? 'Основной' : 'Не основной'),
  },
]
